/*eslint-env jquery*/
import React, { Component } from 'react'
import { ProjectListHeader } from '.';
import { ready } from '../utils';

const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N'];

class RadarChart extends Component {
    constructor(props) {
        super(props);
        this.state = {}
        this.startChart = this.startChart.bind(this);
        this.generateChart = this.generateChart.bind(this);
    }
    componentDidMount() {
        ready(() => this.startChart(this.props.data));
    }
    componentDidUpdate() {
        this.startChart(this.props.data);
    }
    startChart(chartData) {
        if (!chartData) return null;
        const ChartJs = function () { };
        const self = this;
        ChartJs.prototype.respChart = function (selector, type, data, options) {
            const ctx = selector.get(0).getContext("2d");
            $(window).resize(() => {
                // eslint-disable-next-line
                new Chart(ctx, { type: 'radar', data: data, options: options });
            });
            // eslint-disable-next-line
            new Chart(ctx, { type: 'radar', data: data, options: options });
        }
        ChartJs.prototype.init = function () {
            const indicators = (((chartData || {}).indicators || {}).projected || []);
            if (indicators.length <= 2) return;
            this.respChart($("#" + self.props.id), 'Radar', self.generateChart(chartData), { height: 300 });
        }
        $.ChartJs = new ChartJs();
        $.ChartJs.Constructor = ChartJs
        $.ChartJs.init();
    }
    generateChart(data) {
        return {
            labels: data.indicators.projected.map((i, index) => (`Q.${letters[index]}`)),
            datasets: [
                {
                    label: "Projected results",
                    backgroundColor: "rgba(179,181,198,0.2)",
                    borderColor: "rgba(179,181,198,1)",
                    pointBackgroundColor: "rgba(179,181,198,1)",
                    pointBorderColor: "#fff",
                    pointHoverBackgroundColor: "#fff",
                    pointHoverBorderColor: "rgba(179,181,198,1)",
                    data: data.indicators.projected.map(i => i.result.input)
                },
                {
                    label: "Actual Results",
                    backgroundColor: "rgba(59, 175, 218,0.2)",
                    borderColor: "rgba(59, 175, 2182,1)",
                    pointBackgroundColor: "rgba(59, 175, 218,1)",
                    pointBorderColor: "#fff",
                    pointHoverBackgroundColor: "#fff",
                    pointHoverBorderColor: "rgba(59, 175, 218,1)",
                    data: data.indicators.actual.map(i => i.result.input)
                }
            ]
        }
    }
    render() {
        const indicators = (((this.props.data || {}).indicators || {}).projected || []);
        return (
            <div className="row">
                <div className="col-12" style={{ marginBottom: 24 }}>
                    <ProjectListHeader title={this.props.title} description={this.props.description} />
                </div>
                {indicators.length <= 2 &&
                    <div className="col-12" style={{ marginBottom: 24 }}>
                        <span><b>You need more informations inside Indicators section to generate charts. Please, fill all sectors to generate the chart results.</b></span>
                    </div>
                }
                <div className="col-6">
                    {indicators.length > 2 && indicators.map((i, index) => {
                        return (
                            <p><b>Q.{letters[index]}</b> <span>{i.indicator.measure}</span></p>
                        )
                    })}
                </div>
                {indicators.length > 2 &&
                    <div className="col-4">
                        <div id="portlet7" className="panel-collapse collapse show">
                            <div className="portlet-body">
                                <canvas id={this.props.id} height="300"></canvas>
                            </div>
                        </div>
                    </div>
                }
            </div>
        )
    }
}

RadarChart.defaultProps = {
    data: {
        indicators: {
            projected: [],
            actual: []
        },
        labels: [],
        datasets: []
    }
}

export default RadarChart;


// WEBPACK FOOTER //
// ./src/components/RadarChart.js